import React from 'react';
import {NavLink} from "react-router-dom";
import {HomeworkItem} from "features/model/types/student-info/studentsInfoHomeworksShema";
import {ReactComponent as ArrayIcon} from '../../../../../../../../../assets/main/groups/main-table/array.svg';


interface IStudentsHomeWorksItems {
    homework: HomeworkItem;
    studentId: string | undefined
}

export const StudentsHomeWorksItems = ({homework, studentId}: IStudentsHomeWorksItems) => {
    return (
        <div className="row">
            <div className="col homework-col full-width-mobile">
                <span className="col-title">Домашнее задание</span>
                <p>
                    <a href="">{homework.date}</a>
                </p>
            </div>
            <div className="col lesson-col auto-width full-width-mobile">
                <span className="col-title">Занятие</span>
                <p>
                    <NavLink style={{borderBottom: 'none', textShadow: 'none'}}
                             to={`/lessons/${homework.lessonId}/home-work/${studentId}`}>{homework.lessonTitle}
                    </NavLink>
                </p>
            </div>
            <div className="col status-col full-width-mobile">
                <span className="col-title">Статус</span>
                {homework.status === 'done' ? (
                    <p className="status-item">
                        <span>Выполнено</span>
                    </p>
                ) : homework.status === 'notDone' ? (
                    <p className="status-item not-done">
                        <span>Не выполнено</span>
                    </p>
                ) : homework.status === 'homeworkNotAssigned' ? (
                    <p className="status-item no-homework">
                        <span>Не задавали</span>
                    </p>
                ) : homework.status === 'partiallyDone' ? (
                    <p className="status-item partially-done">
                        <span>Частично выполнено</span>
                    </p>

                ) : homework.status === 'notVerified' ? (
                    <p className="status-item not-assigned">
                        <span>Не проверено</span>
                    </p>
                ) : homework.status === 'notAssigned' ? (
                        <p className="status-item not-assigned">
                            <span>Не сдано</span>
                        </p>
                    )
                    : null}
            </div>
            <div className="col btn-link-col">
                <NavLink className="circle-arrow-btn" to={`/lessons/${homework.lessonId}/home-work/${studentId}`}>
                    <ArrayIcon/>
                </NavLink>
            </div>
        </div>
    );
};

